// extracted by mini-css-extract-plugin
export default {"button":"ULXLLu","secondary":"sFHMHu","dark":"tKj_Y2","light":"WaT3C4"};